import { STATUS } from '../StepperForm.constants';
import { StepperFormNavDesktop } from './StepperFormNav.desktop';
import { StepperFormNavMobile } from './StepperFormNav.mobile';
import { StepperFormNavProps } from './StepperFormNav.types';

export const StepperFormNav: React.FC<StepperFormNavProps> = ({
  isLinear,
  isMobile,
  status,
  ...props
}) => {
  const isLoading = status === STATUS.loading;
  const StepperFormNavComponent = isMobile
    ? StepperFormNavMobile
    : StepperFormNavDesktop;

  if (isMobile && isLinear) {
    return null;
  }

  return (
    <StepperFormNavComponent
      isLoading={isLoading}
      isLinear={isLinear}
      {...props}
    />
  );
};
